import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {userActions} from "../../redux-modules/UserModule";
export default function ServiceHubspotForm() {
    const dispatch = useDispatch();
    
    window.addEventListener('message', event => {
        if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
            dispatch(userActions.hubspotFormSubmitted());
            return false;
        }
    });
    
    useEffect(() => {
        if (window.hbspt) {
            window.hbspt.forms.create({
                region: "na1",
                portalId: window.IsProduction() ? process.env.REACT_APP_HUBSPOT_SERVICE_FORM_PORTALID_PROD : process.env.REACT_APP_HUBSPOT_SERVICE_FORM_PORTALID_TEST,
                formId: window.IsProduction() ? process.env.REACT_APP_HUBSPOT_SERVICE_FORM_ID_PROD : process.env.REACT_APP_HUBSPOT_SERVICE_FORM_ID_TEST,
                target: "#hubspotServiceForm"
            });
        }
    })
    return <div id="hubspotServiceForm"></div>;
}